export default function ErrorPrompt(props) {
    return <div className='form-item-input-error'>{props.children}</div>;
}